exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deals_loading {\n  transition: -webkit-filter 0.5s;\n  transition: filter 0.5s;\n  transition: filter 0.5s, -webkit-filter 0.5s;\n  -webkit-filter: none;\n          filter: none;\n}\n\n.deals_loading.deals_loadingAreLoading {\n  -webkit-filter: grayscale(75%);\n          filter: grayscale(75%);\n}\n", ""]);

// exports
